








import { Component, Vue } from 'vue-property-decorator';
import AppAside from '@/component/layout/app/aside.vue';
import AppMain from '@/component/layout/app/main.vue';
import storage from 'baimahu/storage';
import { Action } from 'vuex-class';
import { ACTION_RELOAD_BASIS, ACTION_GET_PERMISSION } from '@/store/type';

@Component({
  components: {
    AppAside,
    AppMain,
  }
})
export default class AppLayout extends Vue {
  @Action(ACTION_RELOAD_BASIS) globalReloadBasis!: () => void;

  loading: boolean = false;

  async created() {
    this.loading = true;
    if (!sessionStorage.getItem('merchant_type')) {
       await this.globalReloadBasis();
    }
    this.loading = false;
  }
}
